// Fader V10.7
// used for fading in items, if needed after being loaded, based on scroll
// also copy _fader.scss

// init: fader = new Fader(); fader.init();

// usage: add fader class to items that should fade
// set fader and fader--loader class on loading element or a parent element
// every fader--loader lazyloads by default
// add fader--not-lazy on fader--loader to load it immediately
// loader can de used for a single image, video or background-image
// loader uses data-src and data-srcset instead of src(set)
// can use data-src(set)-mobile
// can use data-src-fullscreen with fader--fullscreen
// add fader--repeat to fade every time it crosses a fold
// add fader--no-top to only fade from the bottom fold, not the top
// add fader--out-of-view to fade elements that are outside the viewport (top/right/bottom/left)
// add fader--still to fade in without transform, just opacity
// add fader--no-fade for no transition, but just show the element
// add fader--clip to clip the element, instead of opacity
// add fader--clip-hor to clip the element from left to right, instead of top to bottom
// add fader--no-stagger to not stagger the fade in, can still use data-fader-delay
// add data-fader-duration="600" to set a custom fade duration in ms for that element
// fader--force is optional legacy support to force fade on in-view items during skipOnLoadInView

// required properties:
// none

// possible properties:
// fadeDur = 1200: set this to fader.scss fade speed, in ms
// stagger = 80: in ms
// maxFades = 40: max number of staggering items
// preFadeResizeDur = 0: for resizing used after knowing image size, in ms, set to image size transition duration
// afterLoadFunction = '': because now stuff has loaded and size is known call this function
// fadeScrollersSelector = '': what selectors uses scrolling except the body
// classesToRemove = []: what classes that you added should be removed from the element, for instance ['fader--grow']
// if you are looking on a horizontal mobile device. Probably set to false if using video that covers the viewport. Set to true if just using a smaller filesize
// mobileMq = '(max-width: 599px)': decides when the data-src(set)-mobile is used
// blockResizeObserver = false: block the observer from calling setFaders
// lazyFoldDiff = 1000: load images before they are visible for lazyFoldDiff pixels
// fadeOutOfView = false: fade elements regardless of viewport position
// fadeHorizontally = false: set to true to use horizontal viewport checks for fades and horizontal lazy preload using lazyFoldDiff
// addStaggerToFaderDelay = true: turn false to only use data-fader-delay instead of stagger ánd data-fader-delay (fader--no-stagger does the same)
// inViewFadeDelay = 600: set a custom delay for in-view items that are faded (outside VT context), so they fade after view transition
// listenToScroll = true: set to false to not listen to scroll for fading, use fader.fadeBlocks(document.body) manually

// methods:
// fader.init() attach listeners, observer and helper element
// fader.destroy() remove listeners, observer and helper element
// fader.setFaders() when new content is added to the page
// fader.setBlockResizeObserver(true/false) block the observer from calling setFaders
// fader.fadeBlocks(document.body) if scroll doesn't fire
// fader.fadeInHolderAgain(selector for single or element) to redo fade
// fader.fadeElementsAgain(selector for multiple or elements) to redo fade
// fader.resetLoaderElement(element) reset a loader element so it can be loaded/faded again
// fader.enableScrollListen() start listening to scroll for fading
// fader.disableScrollListen() stop listening to scroll for fading

// events on the element:
// fader:in dispatched on the element when it has faded in (after transition completes)

// Example: listen for fade-in completion
// document.querySelector('.fader').addEventListener('fader:in', (event) => {
//   console.log('Faded in:', event.target);
// });

// use .fader--loaded to remove temporary heights for images, for example:
// min-height: 0;
// transition: .2s min-height;
// &:not(.fader--loaded) {
//   min-height: 10rem;
// }

// changelog:
// 4.0 can switch between regular src and mobile src continuously
// 4.1 custom mobileWidth
// 4.1.1 fix for offscreen safari video
// 4.1.2 fix for unmuted videos not playing
// 4.2 switch media queries more nicely and only where needed
// 4.3 css support for clipping
// 4.4 fixes for changing variables
// 4.5 added resize observer
// 4.5.1 eslint
// 4.5.2 add blockResizeObserver fix, cleanup
// 4.5.3 fix resize observer
// 4.6 add no stagger option
// 4.6.2 fix for safari video, cleanup
// 4.6.2 new cover class
// 4.6.3 fix for cover video
// 4.7 new --no-fade, --still, --clip fixes, separate animation duration
// 4.7.1 fix bug with no fade for loaded elements
// 5.0 add lazyload option
// 6.0 no jquery
// 6.1 cleanup
// 6.1.1 use correct window sizes
// 6.2 two seperate fade again functions
// 6.2.1 fix for safari
// 6.2.2 fix wrong offset, add custom lazyFoldDiff
// 6.2.3 cleanup and bugfixes
// 6.2.4 cleanup of getAttribute code
// 6.3 add audio support
// 6.4 fix non-autoplay video autoplaying on ios
// 6.5 add fade below fold option (to hide fade / flash)
// 6.6 fix for faders in scrolling elements, cleanup
// 6.6.1 don't fade again if still fading
// 6.7 add fader repeat option
// 6.8 add top option to fade again
// 6.9 add option for different transition from above fold
// 6.9.1 fix for empty fadeScrollersSelector
// 6.10 add individual fade below option using fader--below-fold
// 6.11 don't fade invisible elements
// 6.12 add data-fader-delay option
// 6.13 new transform options
// 6.14 firefox animation improvements
// 6.15 fix stagger timing
// 6.16 add fader--fullscreen option, which uses data-src-fullscreen, fixes to resizing
// 6.16.1 only add load listeners to element with new src, call less fadeblocks after load
// 6.16.2 fix for loading fixed elements
// 6.17 fix for calling function after load
// 6.18 make resetLoaderElement public
// 6.19 check if src is set before loading with it
// 6.20 fix fadeOutOfView (was fadeBelowFold) with fader--loader
// 6.21 fix flicker from fader--loader
// 6.22 add retina firefox translate support
// 6.23 don't reload media when repeating fade
// 6.24 fix for weird html characters in src
// 6.25 fix for no js browsers
// 6.26 take transform into account for position
// 6.27 trim sources and fix weird characters
// 6.28 don't use LF scss/css vars
// 6.29 fix for no fade on elements that are in view on load
// 6.30 fixes for fcp/lcp
// 6.31 fix 'fade again' for in view on load elements
// 6.32 fix weird characters some more
// 6.33 fixes for skip on load in view
// 6.34 mobile check is now a media query instead of a width check + remove showMobileVideoSrcOnMobileHor
// 6.35 no stagger on test fader
// 6.36 no !important
// 6.37 add fader--force to force fade in when skipping on load in view
// 6.38 add addFaderDelayToStagger option to use data-fader-delay instead of stagger
// 6.39 fixes addFaderDelayToStagger => addStaggerToFaderDelay + fixes + maxFades to 40
// 7.0 can now fade again even when previous fade is not done, both via a function and via scroll
// 7.1 add delay on fader--force, so they fade after view transition
// 7.2 correctly check position for skipOnLoadInView
// 7.2.1 transition fixes in css
// 7.3 don't fade elements that have (parents with) visibility hidden
// 7.4 fadeInHolderAgain and fadeElementsAgain now also work with element(s) instead of selector
// 7.4.1 fix hidden elements in skipOnLoadInView
// 7.4.2 fix fader--force counting for fadersAnimating
// 8.0 take left/right fold into account for fades, no need for fader--top anymore, use fader--no-top for only fading from bottom
// 8.1 calculate hor and vert before skiponloadinview, so they are correct for that, and use hor for left/right fold calculations
// 8.2 respect fader--no-stagger for forced skipOnLoadInView delays, and only decrement fadersAnimating when it was incremented
// 8.3 add fader--clip-hor class for horizontal clip reveal (left to right)
// 8.4 do fadeblocks after 1 frame, so site specific positionings are done
// 8.5 add fadeHorizontally option so lazy loading and fades can ignore horizontal viewport checks
// 8.6 reverse lazy option: all fader--loader items lazyload, use fader--not-lazy to opt out
// 8.7 when fadeHorizontally is true, lazyload from the right edge plus lazyFoldDiff
// 8.8 split lazy fold thresholds into lazyFoldVertical and lazyFoldHorizontal
// 8.9 fade again fader--repeat elements when they become visibility: hidden, fix initializer typo
// 8.10 skipOnLoadInView is now a function, so it can be used with ajax content and view transitions
// 8.11 add listenToScroll option to skip scroll listener
// 8.12 add enableScrollListen and disableScrollListen methods
// 8.13 rename fader--below-fold to fader--out-of-view, rename fadeBelowFold to fadeOutOfView
// 9.0 BREAKING: when skipOnLoadInView runs, which is during a view-transition, in-view elements in a view-transition context skip fading; other in-view elements fade normally
// 9.0.1 cleanup
// 9.0.2 consider descendants too when checking view-transition context
// 9.0.3 rename forceDelay to inViewFadeDelay and remove forceDelay alias
// 10.0 BREAKING: move startup side effects out of the constructor into init(), add destroy(), and add setBlockResizeObserver(value)
// 10.1 remove fadeOnInit because init() now controls startup explicitly
// 10.2 normalize init/destroy internals with private fields and methods
// 10.3 init() now only attaches Fader infrastructure; page setup decides when to call doSkipOnLoadInView() and setFaders()
// 10.4 remove skipOnLoadInView option; callers now decide explicitly when page setup should prepare Fader for a view transition
// 10.5 move resetLoaderElement, fadeInHolderAgain, fadeElementsAgain out of the constructor into real class methods
// 10.6 convert all remaining constructor-local mutable state to private fields; convert all constructor-local helper functions to private class methods; setFaders, fadeBlocks, doSkipOnLoadInView become real class methods
// 10.7 add fader:in custom event on fade completion; add data-fader-duration per-element duration override

export default class Fader {
  #initialized;
  #resizeObserver;
  #faderEl;
  #fadeBlocksTimeout;
  #boundFadeTimeout;
  #boundFadeSelector;
  #boundScroll;
  #boundObserverHandler;
  #boundResize;
  #fadersAnimating;
  #mqMobile;
  #isTouch;
  #fastLoadDuration;
  #windowWidth;
  #windowHeight;
  #prevObserverWidth;
  #prevObserverHeight;
  #innerHeight;
  #lazyFoldVertical;
  #lazyFoldHorizontal;
  #vert;
  #hor;

  constructor({
    fadeDur = 1200,
    stagger = 80,
    maxFades = 40,
    preFadeResizeDur = 0,
    afterLoadFunction = '',
    fadeScrollersSelector = '',
    classesToRemove = [],
    mobileMq = '(max-width: 599px)',
    blockResizeObserver = false,
    lazyFoldDiff = 1000,
    fadeOutOfView = false,
    inViewFadeDelay = 600,
    fadeHorizontally = false,
    addStaggerToFaderDelay = true,
    listenToScroll = true,
  } = '') {
    // console.log('Fader');

    // user variables ------------------------------------------------------------
    // can be changed based on a media query for instance and read
    this.fadeDur = fadeDur;
    this.stagger = stagger;
    this.maxFades = maxFades;
    this.preFadeResizeDur = preFadeResizeDur;
    this.afterLoadFunction = afterLoadFunction;
    this.fadeScrollersSelector = fadeScrollersSelector;
    this.classesToRemove = classesToRemove;
    this.blockResizeObserver = blockResizeObserver;
    this.lazyFoldDiff = lazyFoldDiff;
    this.fadeOutOfView = fadeOutOfView;
    this.inViewFadeDelay = inViewFadeDelay;
    this.fadeHorizontally = fadeHorizontally;
    this.addStaggerToFaderDelay = addStaggerToFaderDelay;
    this.listenToScroll = listenToScroll;

    this.#initialized = false;
    this.#resizeObserver = undefined;
    this.#faderEl = document.createElement('div');
    this.#fadeBlocksTimeout = undefined;
    this.#boundFadeTimeout = undefined;
    this.#boundFadeSelector = undefined;
    this.#boundScroll = undefined;
    this.#boundObserverHandler = undefined;
    this.#boundResize = undefined;

    // scope variables -----------------------------------------------------------
    this.#fadersAnimating = 0;
    this.#mqMobile = window.matchMedia(mobileMq);
    this.#isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

    const ua = navigator.userAgent;
    if (ua.toLowerCase().indexOf('firefox') > -1) document.body.classList.add('body--firefox');

    const mq = window.matchMedia('only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)');
    if ((mq && mq.matches) || window.devicePixelRatio > 1) document.body.classList.add('body--retina');

    this.#windowWidth = 0;
    this.#windowHeight = 0;
    this.#prevObserverWidth = 0;
    this.#prevObserverHeight = 0;
    this.#innerHeight = window.innerHeight; // must use innerHeight because of ios: is actual height of screen
    this.#lazyFoldVertical = this.#innerHeight + this.lazyFoldDiff; // load images before they are visible
    this.#lazyFoldHorizontal = window.innerWidth + this.lazyFoldDiff; // preload images before they enter from the right

    this.#fastLoadDuration = 100;
    this.#vert = 0;
    this.#hor = 0;

    // bound handlers ------------------------------------------------------------
    this.#boundFadeTimeout = () => {
      // console.log('fadeTimeout');
      // resize after certain amount of time, when elements have resized
      // by default this is 100ms
      clearTimeout(this.#fadeBlocksTimeout);
      this.#fadeBlocksTimeout = setTimeout(() => {
        // console.log('fadeTimeout fadeBlocks');
        this.fadeBlocks(document.body);

        if (this.fadeScrollersSelector !== '') {
          const fadeScrollers = document.querySelectorAll(this.fadeScrollersSelector);
          fadeScrollers.forEach(element => {
            this.fadeBlocks(element);
          });
        }

        // call after load function
        if (this.afterLoadFunction) this.afterLoadFunction();
      }, this.preFadeResizeDur);
    };

    this.#boundFadeSelector = event => {
      // after possible site specific scroll calculations
      requestAnimationFrame(() => {
        this.fadeBlocks(event.target);
      });
    };

    this.#boundScroll = event => {
      // console.log('fader scrollHandler');
      // after possible site specific scroll calculations
      requestAnimationFrame(() => {
        this.fadeBlocks(event.target);
      })
    };

    this.#boundObserverHandler = () => {
      // after possible site specific resize calculations
      if (!this.blockResizeObserver) setTimeout(() => this.#observerResize(), 100);
    };

    this.#boundResize = () => {
      // after possible site specific resize calculations
      setTimeout(() => this.setFaders(), 100);
    };
  }

  // -------------------------------------------------------------------------
  // Private helpers
  // -------------------------------------------------------------------------

  #setHorAndVert() {
    this.#windowWidth = document.documentElement.clientWidth;
    this.#windowHeight = document.documentElement.clientHeight;
    this.#innerHeight = window.innerHeight;
    this.#lazyFoldVertical = this.#innerHeight + this.lazyFoldDiff;
    this.#lazyFoldHorizontal = this.#windowWidth + this.lazyFoldDiff;

    this.#faderEl.setAttribute('class', '');

    // calculate --vert and --hor
    const startTop = this.#faderEl.getBoundingClientRect().top;
    this.#faderEl.classList.add('fader', 'fader--no-stagger');
    const endTop = this.#faderEl.getBoundingClientRect().top;
    this.#vert = startTop - endTop;

    const startLeft = this.#faderEl.getBoundingClientRect().left;
    this.#faderEl.classList.add('fader--left');
    const endLeft = this.#faderEl.getBoundingClientRect().left;
    this.#hor = startLeft - endLeft;

    // console.log({vert: this.#vert, hor: this.#hor});
  }

  #observerResize() {
    // console.log('observerResize', this.blockResizeObserver, {windowWidth: this.#windowWidth}, {prevObserverWidth: this.#prevObserverWidth}, {windowHeight: this.#windowHeight}, {prevObserverHeight: this.#prevObserverHeight});

    // observed a resize but browser did not resize, this means content changed, so call setResize
    if (this.#windowWidth == this.#prevObserverWidth && this.#windowHeight == this.#prevObserverHeight && this.#prevObserverWidth != 0 && this.#prevObserverHeight != 0) {
      if (!this.blockResizeObserver) this.setFaders();
    }

    this.#prevObserverWidth = this.#windowWidth;
    this.#prevObserverHeight = this.#windowHeight;
  }

  #getLoadElement(element) {
    // console.log('getLoadElement', {element});
    let loadableElement;

    if (
      element.tagName === 'IMG'
      || element.tagName === 'VIDEO'
      || element.tagName === 'AUDIO'
      || getComputedStyle(element).backgroundImage !== 'none'
    ) {
      loadableElement = element;
    } else {
      const selector = 'img[data-src], video[data-src], audio[data-src], *[style*="background-image:"]';
      loadableElement = element.querySelector(selector);
    }

    return loadableElement;
  }

  #loadElement(element) {
    // console.log('loadElement', {element});
    let loadEl = this.#getLoadElement(element);

    if (!loadEl) {
      // console.log('nothing to load, remove loader, just fade');
      element.classList.remove('fader--loader');
      return;
    }

    // if invisible and not audio, don't fade
    const position = window.getComputedStyle(element).getPropertyValue('position');
    if (element.offsetParent === null && position !== 'fixed' && element.tagName !== 'AUDIO' && loadEl.tagName !== 'AUDIO') return;

    // console.log('loadElement 2', {element}, {loadEl});

    const src = loadEl.getAttribute('data-src');
    const srcMobile = loadEl.getAttribute('data-src-mobile');

    if (loadEl.tagName === 'IMG') {
      // images ----------------------------
      const srcset = loadEl.getAttribute('data-srcset');
      const srcsetMobile = loadEl.getAttribute('data-srcset-mobile');

      if (srcMobile && this.#mqMobile.matches) { // mobile
        this.#addImgLoadCheck(element, loadEl, srcMobile, srcsetMobile);
      } else if (src) {
        // not mobile
        this.#addImgLoadCheck(element, loadEl, src, srcset);
      }
    } else if (loadEl.tagName === 'VIDEO' || loadEl.tagName === 'AUDIO') {
      // video and audio ----------------------------
      const srcFullscreen = loadEl.getAttribute('data-src-fullscreen');
      const isFullscreen = element.classList.contains('fader--fullscreen');

      if (srcMobile && this.#mqMobile.matches) {
        // mobile
        this.#addVideoAudioLoadCheck(element, loadEl, srcMobile);
      } else if (srcFullscreen && isFullscreen) {
        // fullscreen
        this.#addVideoAudioLoadCheck(element, loadEl, srcFullscreen);
      } else if (src) {
        // not mobile or fullscreen
        this.#addVideoAudioLoadCheck(element, loadEl, src);
      }
    } else {
      // background images ----------------------------

      const bgImg = getComputedStyle(element).backgroundImage;
      const imgUrl = bgImg.slice(4, -1).replace(/"/g, '');
      const img = new Image();

      img.removeEventListener('load', () => {});
      img.addEventListener('load', () => {
        img.remove();
        element.style.backgroundImage = `url(${imgUrl}) !important`;

        this.#fadedAfterLoad(element);
      });

      img.src = imgUrl;
    }
  }

  #addImgLoadCheck(element, loadEl, src, srcset) {
    // console.log('addImgLoadCheck', {element}, {loadEl});

    // remove leading and ending spaces, and decode the url
    src = src.trim();
    src = decodeURIComponent(src);

    if (src == decodeURIComponent(loadEl.src)) return;

    this.resetLoaderElement(element);
    loadEl.removeEventListener('load', () => {});
    loadEl.addEventListener('load', () => {
      this.#fadedAfterLoad(element);
    });

    element.classList.add('fader--loading');
    loadEl.src = src;
    if (srcset) {
      // remove leading and ending spaces, and decode the url
      srcset = srcset.trim();
      srcset = decodeURIComponent(srcset);
      loadEl.srcset = srcset;
    }
  }

  #addVideoAudioLoadCheck(element, loadEl, src) {
    // console.log('addVideoAudioLoadCheck', {element}, {loadEl});

    // remove leading and ending spaces, and decode the url
    src = src.trim();
    src = decodeURIComponent(src);

    if (src == loadEl.src) return;

    // all video's play to load
    // couldn't do from loadeddata event, because play sometimes starts after that and pause wouldn't work
    loadEl.removeEventListener('play', () => {});
    loadEl.addEventListener('play', () => {
      // console.log('playing', event, loadEl.dataset.mayplay);
      if (this.#isTouch && loadEl.dataset.autoplay === 'false' && loadEl.dataset.mayplay !== 'true') {
        // in new frame because pause would sometimes not work
        requestAnimationFrame(() => {
          loadEl.autoplay = false;

          loadEl.pause();
          loadEl.currentTime = 0;

          // only do this once, from initial play event used to load video
          loadEl.dataset.mayplay = 'true';
        });
      }

      if (loadEl.getAttribute('data-muted') === 'false') loadEl.muted = false;
    });

    loadEl.removeEventListener('loadeddata', () => {});
    loadEl.addEventListener('loadeddata', () => {
      this.#fadedAfterLoad(element);
    });

    const autoplay = loadEl.getAttribute('data-autoplay');

    if (this.#isTouch && !autoplay) {
      if (loadEl.muted === false) {
        loadEl.setAttribute('data-muted', 'false');
        loadEl.muted = true;
      } else {
        loadEl.setAttribute('data-muted', 'true');
      }

      if (loadEl.autoplay === false) {
        loadEl.setAttribute('data-autoplay', 'false');
        loadEl.autoplay = true;
      } else {
        loadEl.setAttribute('data-autoplay', 'true');
      }
    }

    this.resetLoaderElement(element);
    loadEl.src = src;
  }

  #fadedAfterLoad(element) {
    // console.log('fadedAfterLoad', {element});
    // you need all 3 to stop calling loadElement
    element.classList.remove('fader--loading');
    element.classList.remove('fader--loader');
    element.classList.remove('fader--lazy');

    element.classList.add('fader--loaded');

    // remember it's loaded
    const dataClass = element.getAttribute('data-class');
    if (dataClass.indexOf('fader--loaded') === -1) {
      element.setAttribute('data-class', dataClass + ' fader--loaded');
    }

    this.#boundFadeTimeout();

    const customDuration = element.dataset.faderDuration ? parseInt(element.dataset.faderDuration, 10) : null;
    const duration = element.classList.contains('fader--fast-load') ? this.#fastLoadDuration : (customDuration ?? this.fadeDur);

    setTimeout(() => {
      element.dataset.fadeFromLoad = 'true';
      this.#tryRemoveFaderProperties(element);
    }, parseInt(element.dataset.delay, 10) + duration + this.preFadeResizeDur);
  }

  #getPos(element) {
    // calculate positions without transform
    const rect = element.getBoundingClientRect();
    let {top, bottom, left, right} = rect;

    if (element.classList.contains('fader')) {
      if (element.classList.contains('fader--up')) {
        // is transformed 100%, so add element height
        top -= rect.height;
        bottom += rect.height;
      } else if (element.classList.contains('fader--left')) {
        // is transformed left, so add hor to get natural position
        left += this.#hor;
        right += this.#hor;
      } else if (element.classList.contains('fader--right')) {
        // is transformed right, so subtract hor to get natural position
        left -= this.#hor;
        right -= this.#hor;
      } else {
        // is transformed, so add vert
        top += this.#vert;
        bottom -= this.#vert;
      }
    }

    // console.log('getTop', {top}, {bottom}, {left}, {right}, {innerHeight: this.#innerHeight});
    return {top, bottom, left, right};
  }

  #isVisibilityHidden(el) {
    while (el) {
      if (window.getComputedStyle(el).visibility === 'hidden') {
        return true;
      }

      el = el.parentElement;
    }

    return false;
  }

  #hasOwnViewTransitionContext(el) {
    const styles = window.getComputedStyle(el);
    const transitionName = styles.getPropertyValue('view-transition-name').trim();
    const transitionClass = styles.getPropertyValue('view-transition-class').trim();

    const hasTransitionName = transitionName !== '' && transitionName !== 'none';
    const hasTransitionClass = transitionClass !== '' && transitionClass !== 'none' && transitionClass !== 'normal';

    return hasTransitionName || hasTransitionClass;
  }

  #hasViewTransitionContextTree(el) {
    // Ignore root-level UA context (e.g. html { view-transition-name: root }).
    let currentEl = el;
    while (currentEl && currentEl !== document.body && currentEl !== document.documentElement) {
      if (this.#hasOwnViewTransitionContext(currentEl)) return true;
      currentEl = currentEl.parentElement;
    }

    const descendants = el.querySelectorAll('*');
    for (let i = 0; i < descendants.length; i++) {
      if (this.#hasOwnViewTransitionContext(descendants[i])) return true;
    }

    return false;
  }

  #tryRemoveFaderProperties(element, force = false) {
    // console.log('tryRemoveFaderProperties', 'loaded: ' + element.dataset.fadeFromLoad, 'scrolled: ' + element.dataset.fadeFromScroll, element.classList[0], {force});
    // if faded from scroll and loaded
    // if faded from scroll and not loading
    // if faded from load and scrolling isn't relevant
    if (
      (element.dataset.fadeFromScroll && element.dataset.fadeFromLoad)
      || (element.dataset.fadeFromScroll
        && !element.classList.contains('fader--loader')
        && !element.classList.contains('fader--loading')
        && !element.classList.contains('fader--loaded'))
      || (element.dataset.fadeFromLoad && element.classList.contains('fader--no-scroll'))
      || force
    ) {
      // console.log('remove fader properties', element.classList[0]);

      const defaultClassesToRemove = ['fader', 'fader3', 'fader--no-scroll', 'fader--still', 'fader--no-fade', 'fader--clip', 'fader--clip-hor', 'fader--no-stagger', 'fader--left', 'fader--right', 'fader--bl', 'fader--br', 'fader--shrink', 'fader--lazy', 'fader--top-start', 'fader--up', 'fader--fast-load', 'fader--no-top'];

      for (let i = 0; i < defaultClassesToRemove.length; i++) {
        element.classList.remove(defaultClassesToRemove[i]);
      }

      for (let i = 0; i < this.classesToRemove.length; i++) {
        element.classList.remove(this.classesToRemove[i]);
      }

      if (element.dataset.inViewFadeDelayApplied) {
        element.dataset.inViewFadeDelayApplied = '';

        // remove previously added delay for in-view delayed items
        let resetDelay = parseInt(element.dataset.faderDelay, 10) - this.inViewFadeDelay;
        if (resetDelay < 1) resetDelay = '';
        element.dataset.faderDelay = resetDelay;
      }

      element.dataset.delay = '';

      // leave fader--loaded and fader2 class because they're used elsewhere

      element.style.transitionDelay = '';
      element.style.removeProperty('--fader-duration');
    }
  }

  #fadeAgain(element) {
    // console.log('fadeAgain', element.classList[0]);
    this.#tryRemoveFaderProperties(element, true); // true = force remove fader properties
    element.dataset.faded = '';
    element.dataset.fadeFromScroll = '';
    // element.dataset.fadeFromLoad = ''; // don't reset fade from load, because it might be loaded
    element.setAttribute('class', element.getAttribute('data-class')); // reset class attr
  }

  // -------------------------------------------------------------------------
  // Public methods
  // -------------------------------------------------------------------------

  // when new fader content is added, call this
  setFaders = () => {
    // console.log('setFaders');
    this.#setHorAndVert();

    if (this.fadeScrollersSelector !== '') {
      const fadeScrollers = document.querySelectorAll(this.fadeScrollersSelector);
      fadeScrollers.forEach(element => {
        element.removeEventListener('scroll', this.#boundFadeSelector);
        element.addEventListener('scroll', this.#boundFadeSelector);
      });
    }

    const faderElements = document.querySelectorAll('.fader');
    faderElements.forEach(element => {
      let hasFastLoad = false;
      if (element.classList.contains('fader--fast-load')) {
        hasFastLoad = true;
        // don't add fast-load class to data-class
        // because its should only be used on page load
        element.classList.remove('fader--fast-load');
      }

      if (!element.getAttribute('data-class')) {
        element.setAttribute('data-class', element.getAttribute('class'));
      }

      if (hasFastLoad) element.classList.add('fader--fast-load');

      element.classList.add('fader2');

      if (element.dataset.faderDuration) {
        element.style.setProperty('--fader-duration', parseInt(element.dataset.faderDuration, 10) + 'ms');
      }

      // if above fold, add top transform (unless fader--no-top)
      if (!element.classList.contains('fader--no-top')) {
        const rect = element.getBoundingClientRect();
        if (rect.bottom < rect.height) element.classList.add('fader--top-start'); // not < 0, because a little wiggle room
      }
    });

    const loaderElements = document.querySelectorAll('.fader--loaded.fader--not-lazy, .fader--loader.fader--not-lazy');
    loaderElements.forEach(element => {
      // console.log('loadElement not lazy', {element});
      this.#loadElement(element);
    });

    this.#boundFadeTimeout();
  }

  fadeBlocks = (scrollEl) => {
    // console.log('fadeBlocks', {scrollEl, vert: this.#vert, innerHeight: this.#innerHeight});

    let doSetFaders = false;

    // fade in the blocks when scrolling
    const faderElements = scrollEl.querySelectorAll('.fader2');
    faderElements.forEach((element, index) => {
      // console.log(element.classList[0]);
      if (!element.classList.contains('fader') && !element.classList.contains('fader--repeat')) return;

      // if invisible, don't fade
      const position = window.getComputedStyle(element).getPropertyValue('position');
      if (element.offsetParent === null && position !== 'fixed') return;
      // console.log(this.#isVisibilityHidden(element));
      if (this.#isVisibilityHidden(element)) {
        if (element.classList.contains('fader--repeat') && element.dataset.faded) {
          const random = Math.random().toString(36).substring(2, 15);
          element.dataset.initializer = random;
          this.#fadeAgain(element);
          doSetFaders = true;
        }
        return;
      }

      const pos = this.#getPos(element);

      const inLazyLoadHorizontalView = !this.fadeHorizontally || pos.left < this.#lazyFoldHorizontal;

      // lazy load loader elements before they are visible (unless explicitly non-lazy)
      if (element.classList.contains('fader--loader')
      && !element.classList.contains('fader--not-lazy')
      && ((pos.top < this.#lazyFoldVertical && inLazyLoadHorizontalView) || this.fadeOutOfView)) {
        // console.log('lazy load', {element});
        this.#loadElement(element);
      }

      // console.log(element.classList[0], {pos}, 'faded: ' + element.dataset.faded);

      const inViewVertical = pos.top < this.#innerHeight && (pos.bottom > 0 || element.classList.contains('fader--no-top')); // from top and bottom, unless fader--no-top
      const inViewHorizontal = !this.fadeHorizontally || (pos.left < this.#windowWidth && pos.right > 0);
      // console.log({inViewVertical, inViewHorizontal});

      if ((inViewVertical && inViewHorizontal)
      || this.fadeOutOfView
      || element.classList.contains('fader--out-of-view')) {
        if (element.dataset.faded) return;

        // console.log('fade from scroll prev');
        // only do this once
        element.dataset.faded = 'true';

        // console.log(element.classList[0], this.#fadersAnimating);
        if (element.classList.contains('fader--no-fade')) {
          // non-fading element
          element.classList.add('fader3'); // visible
          element.dataset.fadeFromScroll = 'true';
          this.#tryRemoveFaderProperties(element);
          element.dispatchEvent(new CustomEvent('fader:in', { bubbles: true }));
        } else {
          // console.log('fade element: ', element.classList[0]);
          // fading element
          // add a delayed animation for the animating blocks
          let extraDelay;
          let delay;
          let didIncrementFadersAnimating = false;

          if (element.classList.contains('fader--fast-load')) {
            extraDelay = 0;
            delay = 0;
          } else {
            extraDelay = element.dataset.faderDelay ? parseInt(element.dataset.faderDelay, 10) : '';
            // console.log({extraDelay});

            if (this.addStaggerToFaderDelay || extraDelay === '') {
              if (extraDelay == '') extraDelay = 0;

              // add data-fader-delay to stagger
              delay = (this.stagger * this.#fadersAnimating) + this.preFadeResizeDur + extraDelay;
              // console.log(element.classList[0], {fadersAnimating: this.#fadersAnimating, extraDelay, delay});

              // remember total fading blocks, to get them to not animate at the same time
              if (!element.classList.contains('fader--no-stagger')
              && !element.classList.contains('fader--fast-load')) {
                this.#fadersAnimating++;
                didIncrementFadersAnimating = true;
              }
            } else {
              // use only data-fader-delay
              // doesn't update fadersAnimating, because the delay duration might not align with the default stagger
              delay = extraDelay;
            }
          }

          // console.log(element.classList[0], {delay});
          element.style.transitionDelay = delay + 'ms';
          element.dataset.delay = delay; // remember delay for loading media
          element.classList.add('fader3'); // fade in

          // maxFades so you don't have to wait too long when scrolling down fast
          if (this.#fadersAnimating > this.maxFades) this.#fadersAnimating = this.maxFades;

          // remove stagger
          setTimeout(() => {
            // console.log('start ani');
            if (didIncrementFadersAnimating) {
              this.#fadersAnimating--;
              if (this.#fadersAnimating < 0) this.#fadersAnimating = 0;
            }
          }, delay);

          const customDuration = element.dataset.faderDuration ? parseInt(element.dataset.faderDuration, 10) : null;
          const duration = element.classList.contains('fader--fast-load') ? this.#fastLoadDuration : (customDuration ?? this.fadeDur);

          // console.log('fade from scroll', element.classList[0], {duration}, {delay}, {fadersAnimating: this.#fadersAnimating});

          // console.log({duration, delay});

          // to prevent multiple setTimeout calls
          // this can happen when fadeAgain is called
          const random = Math.random().toString(36).substring(2, 15);
          element.dataset.initializer = random;

          // after fading in
          setTimeout(() => {
            // if these are not the same, it means the element was faded again
            // console.log(random, element.dataset.initializer);
            if (random !== element.dataset.initializer) return;

            element.dataset.fadeFromScroll = 'true';
            this.#tryRemoveFaderProperties(element);
            element.dispatchEvent(new CustomEvent('fader:in', { bubbles: true }));
          }, duration + delay);
        }
      } else if (element.classList.contains('fader--repeat') && element.dataset.faded) {
        // check faded so it's only reset after having faded
        // this is a faded repeat element below bottom, or above top fold
        // console.log('above or below fold, fade again', index);

        // set new random, so code in timeout is not executed after going out of view
        const random = Math.random().toString(36).substring(2, 15);
        element.dataset.initializer = random;

        this.#fadeAgain(element); // adds fader class at the end
        doSetFaders = true;
      }
    });

    if (doSetFaders) this.setFaders();
  }

  // remove fade from elements in view on load that are visible and forced or in a vt context
  doSkipOnLoadInView = (doSetFaders = true) => {
    const faderEls = document.querySelectorAll('.fader');
    // console.log('doSkipOnLoadInView', {doSetFaders});

    let forceTotal = 0;
    faderEls.forEach(faderEl => {
      // skip hidden items
      // if invisible, don't fade
      const position = window.getComputedStyle(faderEl).getPropertyValue('position');
      if (faderEl.offsetParent === null && position !== 'fixed') return;
      // console.log(this.#isVisibilityHidden(faderEl));
      if (this.#isVisibilityHidden(faderEl)) return;

      const pos = this.#getPos(faderEl);

      const inViewVertical = pos.top < this.#innerHeight && pos.bottom > 0;
      const inViewHorizontal = !this.fadeHorizontally || (pos.left < this.#windowWidth && pos.right > 0);

      if (inViewVertical && inViewHorizontal) {
        // faderEl is in view
        const isInViewTransitionContext = this.#hasViewTransitionContextTree(faderEl);
        const shouldFadeInView = faderEl.classList.contains('fader--force') || !isInViewTransitionContext;

        if (shouldFadeInView) {
          // add delay for in-view items that fade (so they fade after view transition)
          let delay = this.inViewFadeDelay;
          const shouldStagger = !faderEl.classList.contains('fader--no-stagger');

          // get original data-fader-delay
          if (faderEl.dataset.faderDelay) {
            // console.log(faderEl.classList[0], 'hasFaderDelay');
            delay += parseInt(faderEl.dataset.faderDelay, 10);

            if (this.addStaggerToFaderDelay && shouldStagger) {
              delay += forceTotal * this.stagger;
              forceTotal++;
            }
          } else {
            // no data-fader-delay, so add stagger based on current in-view delayed item
            if (shouldStagger) {
              delay += forceTotal * this.stagger;
              forceTotal++;
            }
          }

          // console.log(faderEl.classList[0], 'in-view fade after', delay);

          faderEl.dataset.faderDelay = delay;
          faderEl.dataset.inViewFadeDelayApplied = 'true';
        } else if (faderEl.classList.contains('fader--loader')) {
          // faderEl needs loading, so still do fade but faster
          faderEl.classList.add('fader--fast-load');
          // console.log(faderEl.classList[0], 'fast fade');
        } else {
          // faderEl doesn't need loading, so skip fade

          if (!faderEl.getAttribute('data-class')) {
            faderEl.setAttribute('data-class', faderEl.getAttribute('class'));
          }

          // console.log(faderEl.classList, 'skip fade');

          faderEl.classList.add('fader2');
          faderEl.dataset.faded = 'true';
          faderEl.dataset.fadeFromScroll = 'true';
          this.#tryRemoveFaderProperties(faderEl);
        }
      }
    });

    if (doSetFaders) this.setFaders();
  }

  setBlockResizeObserver = (value) => {
    this.blockResizeObserver = value;
  }

  resetLoaderElement = (element) => {
    // console.log('resetLoaderElement', {element});
    this.#tryRemoveFaderProperties(element);

    element.classList.remove('fader--loaded');
    element.classList.remove('fader--loading');
    element.classList.add('fader');
    element.classList.add('fader--loader');
    element.dataset.fadeFromScroll = '';
    element.dataset.fadeFromLoad = '';
    element.dataset.faded = '';

    const loadEl = this.#getLoadElement(element);
    if (loadEl && (loadEl.tagName === 'IMG' || loadEl.tagName === 'VIDEO')) {
      loadEl.setAttribute('src', '');
      loadEl.setAttribute('srcset', '');
    }
  }

  fadeInHolderAgain = (holder) => {
    // console.log('fadeInHolderAgain', holder);
    if (!holder) return;

    let holderEl;
    if (holder instanceof Element) {
      holderEl = holder;
    } else {
      holderEl = document.querySelector(holder);
      if (!holderEl) return;
    }

    const elements = holderEl.querySelectorAll('.fader2');
    elements.forEach(el => this.#fadeAgain(el));
    this.setFaders();
  }

  fadeElementsAgain = (selector) => {
    // console.log('fadeElementsAgain', selector);
    if (!selector) return;

    let elements;
    if (selector instanceof NodeList) {
      elements = selector;
    } else if (selector instanceof Element) {
      elements = [selector];
    } else {
      elements = document.querySelectorAll(selector);
      if (!elements) return;
    }

    elements.forEach(el => this.#fadeAgain(el));
    this.setFaders();
  }

  enableScrollListen = () => {
    if (this.listenToScroll) return;
    this.listenToScroll = true;
    document.addEventListener('scroll', this.#boundScroll);
  }

  disableScrollListen = () => {
    if (!this.listenToScroll) return;
    this.listenToScroll = false;
    document.removeEventListener('scroll', this.#boundScroll);
  }

  init = () => {
    // console.log('Fader init', {'#initialized': this.#initialized});
    if (this.#initialized) return false;
    this.#initialized = true;

    if (!this.#faderEl.isConnected) {
      document.body.insertBefore(this.#faderEl, document.body.firstChild);
    }

    this.#setHorAndVert();

    window.addEventListener('load', this.#boundFadeTimeout);
    if (this.listenToScroll) document.addEventListener('scroll', this.#boundScroll);
    window.addEventListener('resize', this.#boundResize);

    const el = document.querySelector('body');
    if (el) {
      this.#resizeObserver = new ResizeObserver(this.#boundObserverHandler);
      this.#resizeObserver.observe(el);
    }

    return true;
  }

  destroy = () => {
    if (!this.#initialized) return;
    this.#initialized = false;

    window.removeEventListener('load', this.#boundFadeTimeout);
    document.removeEventListener('scroll', this.#boundScroll);
    window.removeEventListener('resize', this.#boundResize);

    if (this.fadeScrollersSelector !== '') {
      const fadeScrollers = document.querySelectorAll(this.fadeScrollersSelector);
      fadeScrollers.forEach(element => {
        element.removeEventListener('scroll', this.#boundFadeSelector);
      });
    }

    if (this.#resizeObserver) {
      this.#resizeObserver.disconnect();
      this.#resizeObserver = undefined;
    }

    clearTimeout(this.#fadeBlocksTimeout);

    if (this.#faderEl.isConnected) {
      this.#faderEl.remove();
    }
  }
}
